export default {
  title: '我的收藏',

  menuMusic: '音乐收藏',
  menuLib: '歌单收藏',
  menuSinger: '音乐人收藏',

  tableEmtpy: '暂无音乐收藏记录，快去全部音乐看看吧～',
}